module.exports = __webpack_public_path__ + "static/media/step3@2x.6db735f8.webm";